import { ImCheckboxChecked, ImCheckboxUnchecked } from "react-icons/im";

export const CheckboxField: React.FC<{
  name: string;
  label: string;
  className?: string;
  checked: boolean;
  disabled: boolean;
  onChange: () => void;
}> = ({ name, label, className, checked, disabled, onChange }) => (
  <div className={`relative h-20 w-full sm:w-full color flex flex-col p-3 rounded items-start ${className}`}>
    <p className="font-semibold w-full">{label}</p>
    <label htmlFor={name} className="block text-sm font-medium text-gray-600">
      {checked ? (
        <div className="flex gap-2 items-center justify-start text-greenPrimary">
          <ImCheckboxChecked />
          <span>Verificado</span>
        </div>
      ) : (
        <div className="flex gap-2 items-center justify-start text-redPrimary">
          <ImCheckboxUnchecked />
          <span>Não verificado</span>
        </div>
      )}
    </label>
    <input
      id={name}
      name={name}
      type="checkbox"
      checked={checked}
      onChange={onChange}
      className="border p-2 rounded w-full absolute opacity-0"
      disabled={disabled}
    />
  </div>
);

export const InfoField: React.FC<{
  name: string;
  label: string;
  className?: string;
  checked: boolean;
}> = ({ name, label, className, checked }) => (
  <div className={`relative h-20 w-full sm:w-full color flex flex-col p-3 rounded items-start ${className}`}>
    <p className="font-semibold w-full">{label}</p>
    <label htmlFor={name} className="block text-sm font-medium text-gray-600">
      {checked ? (
        <div className="flex gap-2 items-center justify-start text-greenPrimary">
          <ImCheckboxChecked />
          <span>Verificado</span>
        </div>
      ) : (
        <div className="flex gap-2 items-center justify-start text-redPrimary">
          <ImCheckboxUnchecked />
          <span>Não verificado</span>
        </div>
      )}
    </label>
  </div>
);
